import axios from "@/axios-instance";

export async function checkLotteryCode(merchantId, code){
    return new Promise(((resolve, reject) => {
        axios.post(`/v1/merchants/${merchantId}/lottery/check`, {code})
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            })
    }));
}
